import { Action } from "redux"

export const CLEAR_FEED_ITEMS = 'CLEAR_FEED_ITEMS'
export const clearFeedItems = (): Action<typeof CLEAR_FEED_ITEMS> => ({
    type: 'CLEAR_FEED_ITEMS'
})